/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import Page from "components/common_components/Page/Page";
import Form from "./Form";
import { useDispatch } from "react-redux";
import { notifySuccess, notifyError } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import SettingsContext from "../SettingsContext";
import Button from "components/common_components/Button";

function Configurations() {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [configurations, setConfigurations] = useState([]);
    const [mode, setMode] = useState("view");

    const { Configurations } = useContext(SettingsContext);

    function getConfigurations() {
        setIsLoading(true);
        Configurations.getAll({
            onSuccess: (data) => {
                setConfigurations(data);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    useEffect(() => {
        getConfigurations();

        return () => {
            getConfigurations([]);
            setMode("view");
        };
    }, []);

    function onCancelHandler() {
        setMode("view");
    }

    function onSuccess(_, setSubmitting) {
        setSubmitting(false);
        onCancelHandler();
        dispatch(notifySuccess(`System Parameter saved successfully!`));
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    async function onSubmitHandler(values, { setSubmitting, setErrors }) {
        try {
            setSubmitting(true);
            const response = await Configurations.patchAllAsync(values);
            onSuccess(response, setSubmitting);
        } catch (error) {
            onError(error, setSubmitting, setErrors);
        }
    }

    function onAddHandler() {
        setMode("update");
    }

    return (
        <Page>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Form
                        data={configurations}
                        mode={mode}
                        onSubmit={onSubmitHandler}
                        onCancel={onCancelHandler}
                        title="System Parameters"
                    />
                    {mode === "view" && (
                        <div className="button-group">
                            <Button onClick={onAddHandler} primary>
                                Change
                            </Button>
                        </div>
                    )}
                </>
            )}
        </Page>
    );
}

export default withRouter(Configurations);
